import { saveNoCacheValue } from './no-cache-links';

declare const wp: any;
declare const crscNscData: {
    nonce: string;
};

/**
 * Initializes the NSC Member Pricing functionality to verify that a customer has a valid membership number to get the
 * member price.
 *
 * Validates user input and reloads the page upon successful confirmation to reflect the NSC price for an eligible product.
 *
 */
export const initNSCMemberPrice = () => {
    const form = document.getElementById('nsc-member-pricing-form') as HTMLFormElement | null;
    const confirmBtn = document.getElementById('confirm_nsc_member_code') as HTMLButtonElement | null;
    const inputField = document.getElementById('nsc_member_code') as HTMLInputElement | null;
    const messageDiv = document.getElementById('nsc_confirmation_message');

    if (form && confirmBtn && inputField && messageDiv) {
        form.addEventListener('submit', (event) => {
            event.preventDefault();

            const code = inputField.value.trim();
            const nonceInput = form.querySelector('input[name="nsc_nonce"]') as HTMLInputElement | null;
            const nonce = nonceInput ? nonceInput.value : '';

            if (!code) {
                messageDiv.textContent = 'Please enter a member number.';
                messageDiv.style.color = 'red';
                return;
            }

            confirmBtn.disabled = true;
            messageDiv.textContent = 'Verifying membership number...';
            messageDiv.style.color = 'inherit';

            wp.apiFetch({
                path: 'crsc-dbs/v1/confirm-nsc_member_code',
                method: 'POST',
                data: { 
                    code: code,
                    nsc_nonce: nonce
                },
                headers: {
                    'X-WP-Nonce': crscNscData.nonce
                },
                credentials: 'include'
            })
            .then((data: { success: boolean }) => {
                if (data.success) {
                    messageDiv.textContent = 'Member number confirmed! Reloading page...';
                    messageDiv.style.color = 'green';
                    // Reload page with updated NSC member prices and bust the cache
                    let currentUrl = new URL(window.location.href);
                    let randomValue = Date.now() + btoa( code );
                    saveNoCacheValue( randomValue );
                    currentUrl.searchParams.set('crsc_no_cache', randomValue);
                    window.location.href = currentUrl.toString();
                } else {
                    messageDiv.textContent = 'Invalid member number. Please try again.';
                    messageDiv.style.color = 'red';
                    confirmBtn.disabled = false;
                }
            })
            .catch((error: any) => {
                if (error.hasOwnProperty( 'message' ) ) {
                    messageDiv.textContent = error.message;
                } else {
                    messageDiv.textContent = 'An error occurred. Please try again later.';
                }

                messageDiv.style.color = 'red';
                confirmBtn.disabled = false;
            });
        });
    }
};
